import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { actions, selectors } from '../../modules/customer/profile';
import LoadingPanel from './LoadingPanel';

const SMSBox = ({sendSms, smsStatus, customerId, toggleButton, buttonEnabled, defaultPhoneNumber, defaultSmsContent=''}) => {

    let smsText;
    let smsPhoneNumber;
    const buttonClass = classnames('smsButton', { disabled: !buttonEnabled });
    const formattedPhoneNumber = defaultPhoneNumber.startsWith("+47") ? defaultPhoneNumber : "+47" + defaultPhoneNumber;
    const phoneValidationPattern = "[+47][0-9]{10}";
    const ValidatePhoneNumber = (phone) => phone.value.length > 0;

    return (
        <form className="smsBox">
            <div className="row">
                <div className="col-xs-12">
                    <textarea
                        placeholder="Skriv SMS"
                        ref={node => smsText = node}
                        onChange={e => toggleButton(smsText.value.length > 0 && ValidatePhoneNumber(smsPhoneNumber))}
                        defaultValue={defaultSmsContent}>                        
                    </textarea>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <input type="text" placeholder="Telefonnummer" pattern={phoneValidationPattern} defaultValue={formattedPhoneNumber}
                        ref={node => smsPhoneNumber = node}
                        onChange={e => toggleButton(smsText.value.length > 0 && ValidatePhoneNumber(smsPhoneNumber))}
                        />
                    {
                        (smsStatus === "send_request") &&
                        <LoadingPanel useSmallLoadingPanel={true} />
                    }
                    {
                        (smsStatus === "send_failure") &&
                        <div className="text-danger">Kunne ikke sende sms!</div>
                    }
                    {
                        (smsStatus === "send_success") &&
                        <div className="text-success">Vellykket sendte sms</div>
                    }
                </div>

            </div>
            <div className="row">
                <div className="col-xs-12">
                    <button className={buttonClass} onClick={e =>
                                                                {
                                                                    e.preventDefault();
                                                                    sendSms(customerId, smsPhoneNumber.value, smsText.value)
                                                                }
                                                            }>
                        <span>Send SMS</span>
                    </button>
                </div>
            </div>
        </form>
    );
}

SMSBox.propTypes = {
    smsStatus: PropTypes.string,
    customerId: PropTypes.number.isRequired,
    toggleButton: PropTypes.func.isRequired,
    buttonEnabled: PropTypes.bool,
    defaultPhoneNumber: PropTypes.string
};

const mapStateToProps = createStructuredSelector({
    customerId: selectors.getCustomerID,
    buttonEnabled: selectors.smsButtonEnabled,
    defaultPhoneNumber: selectors.getCustomerPhone,
    smsStatus: selectors.getSmsStatus
});

const mapDispatchToProps = (dispatch, props) => ({
    toggleButton: (enabled) => dispatch(actions.toggleButton(enabled)),
    sendSms: (customerId, smsPhoneNumber, smsText) => dispatch(actions.sendSMS(customerId, smsPhoneNumber, smsText))
});

export default connect(mapStateToProps, mapDispatchToProps)(SMSBox);
